import cn from 'classnames';

import { IConDefaultType } from '../../types';

export enum LogoutIconVariant {
  DEFAULT = 'default',
}
export interface ILogoutIconProps extends IConDefaultType {
  variant?: LogoutIconVariant;
}

export default function LogoutIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = LogoutIconVariant.DEFAULT,
}: ILogoutIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === LogoutIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M8.5 16H5.16667C4.72464 16 4.30072 15.8595 3.98816 15.6095C3.67559 15.3594 3.5 15.0203 3.5 14.6667V5.33333C3.5 4.97971 3.67559 4.64057 3.98816 4.39052C4.30072 4.14048 4.72464 4 5.16667 4H8.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.3359 14.1673L16.5026 10.0007L12.3359 5.83398"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M16.5 10H6.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </i>
  );
}
